module.exports = __webpack_public_path__ + "static/media/icon-drenaje.ef239081.svg";